import { http } from 'connex-cds';

export default {
  setupCompany: ({ entityRef }) => http.post({ apiName: 'cxp', path: `/admin/${entityRef}/setup` }),
  webhooks: ({ entityRef }) => http.get({ apiName: 'dispatch', path: `/${entityRef}/hooks?activeOnly=false` }),
};
